var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon_ToolBar_Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.93408 61C7.23964 61 5.78858 60.4022 4.5809 59.2066C3.37322 58.011 2.77041 56.5755 2.77247 54.9V12.2C2.77247 10.5225 3.3763 9.08595 4.58398 7.89035C5.79166 6.69475 7.24169 6.09797 8.93408 6.1H12.0149V0H18.1765V6.1H42.823V0H48.9846V6.1H52.0654C53.7598 6.1 55.2109 6.6978 56.4186 7.8934C57.6262 9.089 58.2291 10.5245 58.227 12.2V54.9C58.227 56.5775 57.6232 58.014 56.4155 59.2096C55.2078 60.4052 53.7578 61.002 52.0654 61H8.93408ZM8.93408 54.9H52.0654V24.4H8.93408V54.9Z",
    fill: "#FEDE79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarCalendar);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_Calendar.9c6d546202a0c58c014a500a8564f7fe.svg";
export { ForwardRef as ReactComponent };